import { ClientRequestDetails, ClientRequestItemStatus } from '@aiwyn/api';
import { ITEM_REQUEST_STATUS_COLOR, ITEM_REQUEST_STATUS_LABEL } from '../../../../utility/status-labels-dictionaries';
import { BadgeColor } from '@aiwyn/shared';
import { RequestItemFilters, RequestItemStatusFilterOption } from '../../models';

export interface RequestListTotalsData {
  type: RequestItemStatusFilterOption;
  color: BadgeColor;
  label: string;
  total: number;
  active: boolean;
  disabled: boolean;
}

export function calculateClientRequestListItemsTotals(
  requestDetails: ClientRequestDetails,
  requestStatusFilters: RequestItemFilters,
): RequestListTotalsData[] {
  try {
    const sections = requestDetails?.sections ?? [];

    const sortedSelectedStatuses = [
      ClientRequestItemStatus.OPEN,
      ClientRequestItemStatus.IN_REVIEW,
      ClientRequestItemStatus.REJECTED,
      ClientRequestItemStatus.DONE,
    ];

    const initState = sortedSelectedStatuses.reduce(
      (acc, status) => ({
        ...acc,
        [status]: {
          type: status,
          color: ITEM_REQUEST_STATUS_COLOR[status] ?? 'blue',
          label: ITEM_REQUEST_STATUS_LABEL[status] ?? status,
          total: 0,
          active: requestStatusFilters?.status?.[status] ?? false,
        },
      }),
      {} as Record<ClientRequestItemStatus, RequestListTotalsData>,
    );

    const totals = sections
      .flatMap(({ items }) => items)
      .reduce(
        (acc, item) => ({
          ...acc,
          [item.status]: {
            ...acc[item.status],
            total: acc[item.status]?.total + 1 || 1,
          },
        }),
        initState,
      );

    const final = Object.entries(totals).reduce(
      (acc, [status, value]) => ({
        ...acc,
        [status]: {
          ...value,
          disabled: value.total === 0,
        },
      }),
      {} as Record<ClientRequestItemStatus, RequestListTotalsData>,
    );

    return Object.values(final);
  } catch (error) {
    console.error('MARTIN DEBUG', error);
    return [];
  }
}
